import './App.css';
import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';




	
class Ticker extends React.Component {
	constructor(props) {
		super(props);
		// // console.log("ticker properties: ", props);
		this.number = props.locationNumber;
		// // console.log("number: " + this.number);
		this.state = {message: "", oldOrNew: "n"};
		this.newTickCount = 99999;
		this.checkTime = 1000;
		this.color = '#000000';
	}

	componentDidMount() {
		this.timerID = setInterval(
		  () => this.tick(),  this.checkTime
		);
    }
	
	tick() {
		// console.log("Ticker.tick");
		this.handleActualData();
    }; 	

	handleActualData() {
		let actualData = JSON.parse(localStorage.getItem("actualData"));
		// console.log("handleActualData: " + JSON.stringify(actualData));
		let locationData = "";
		actualData.locations.forEach((location) => {
			// console.log("" + location.number + " vs " + this.props.locationNumber);
			if ( location.number === this.props.locationNumber) {
				// console.log("found location: " + JSON.stringify(location));
				locationData = location;
			}
		})
		// console.log("locationData=" + JSON.stringify(locationData));
		let newState = String(locationData.status);
		let oldState = String(this.state.message);
		// this.printString(oldState);
		// this.printString(newState);
		
		if ( newState !== oldState ) {
			// console.log("new status: <" + newState + ">, old was: <" + oldState + ">");
			this.newTickCount = 0;
			// console.log(this.props.locationName + " new state");
			this.color = '#ff0000';
			this.setState({oldOrNew: "n", message: locationData.status});
		} else {
			// console.log("state: " + JSON.stringify(this.state));
			// console.log("newTickCount: " + this.newTickCount + " checkTime = " + this.checkTime);
			if ( this.newTickCount > (10000 / this.checkTime) ) {
				if ( this.state.oldOrNew === 'n' ) {
					// console.log(this.props.locationName + " old state, newTickCount=" + this.newTickCount);
					this.color = '#000000';
					this.setState({oldOrNew: "o"});
				}
			}
		}
		this.newTickCount++;
		this.setState({newTickCount: this.newTickCount});
	}

	printString(str) {
		let index;
		let test_string="";
		// console.log("printstring(" + str + ")");
		for ( index=0; index < str.length; index++ ) {
			test_string = test_string + str.charCodeAt(index) + " ";
		}
		
		// console.log(test_string);
	}
	
	render() {
		// console.log("render Ticker nr " + this.props.locationNumber);
		let parts = String(this.state.message).split(":");
		let part2 = "";
		let index;
		// console.log("parts=" + parts);
		for (index=1; index < parts.length; index++ ) {
		
			if ( index === 1 ) {
				part2 = part2 + parts[index];
			} else {
				part2 = part2 + ":" + parts[index];
			}
			// console.log(part2);
		}
		return (
		<tr>
				<td>
					{this.props.locationName}
				</td>
				<td style={{color: this.color}} >
					{parts[0]}
				</td>
				<td style={{color: this.color}} >
					{part2}
				</td>
		</tr>			
		)
	}
}
		

class LiveTicker extends React.Component {
		constructor(props) {
			super(props);
			const queryParams = new URLSearchParams(window.location.search);
		
			this.tournamentId = queryParams.get('tn');
			this.state = {locations: [], tn: ''}
			this.tickTime = 5000;

		}


	componentDidMount() {
     
		this.timerID = setInterval(
		  () => this.tick(),  this.tickTime
		);
    }
	
	tick() {
		// console.log("Parent.tick: get Data for tournament " + this.tournamentId);
		
		fetch(`https://sd-development.ch/showdown/liveticker?tn=${this.tournamentId}`)
			.then(response =>  {
				// console.log("response: " + response.toString());
				return response.json()
			} )
			.then(data => {
				console.log("text: " + JSON.stringify(data));
				this.handleResponseData(data);
			})
			.catch((error) => {
				// console.log("fetch error: " + error);
			})
    }; 
	


	handleResponseData(data) {
		// console.log("store data: " + JSON.stringify(data));
		localStorage.setItem("actualData", JSON.stringify(data));
		// console.log("locations: " + JSON.stringify(data));
		this.setState({locations:data.locations});
		this.setState({tn:data.tn})
	}
	
	

	componentWillUnmount() {
		clearInterval(this.timerID);
	}	
	
	 
	 render() {
		 // console.log("render LiveTicker:  locations: "  + JSON.stringify(this.state.locations));
		 return ( 
		 <div className="container align-items-center">
			<div className="jumbotron text-center  ">
				<div className="col-9">
					<h1>Live Ticker for<br/> {this.state.tn}</h1>
				</div>
			</div>
			<div className="table-responsive">
				<table className="table table-striped table-sm">
					<tbody>
						{this.state.locations.map((location, idx) => <Ticker key={"t_"+location.number} tournamentId={this.tournamentId} locationName={location.name} locationNumber={location.number} />)}
					</tbody>
				</table>
			</div>
		</div>
		 )
	 }
}
		 
function App() {
  return (
    <div className="App">
		<LiveTicker />
    </div>
  );
}		 
		
	

export default App;
